<template>
  <div class="layout-container">
    <anonymous-page-bar />
    <br>
    <br>
    <v-main>
      <slot />
    </v-main>
    <br>
    <br>
    <anonymous-page-footer />
  </div>
</template>

<script>
  import AnonymousPageBar from '@/layouts/AnonymousPageBar.vue'
  import AnonymousPageFooter from '@/layouts/AnonymousPageFooter.vue'

  export default {
    name: 'AnonymousPageLayout',
    components: {
      AnonymousPageBar,
      AnonymousPageFooter,
    },
  }
</script>

<style>
  .layout-container {
    margin-top: 56px !important;
  }

  .ios-platform .layout-container {
    margin-top: calc(56px + env(safe-area-inset-top)) !important;
  }
</style>
